import BrowserStorage from '../BrowserStorage'

const SessionStorage = new BrowserStorage(sessionStorage)

export default SessionStorage
